import { motion } from 'framer-motion';
import React from 'react';
import './Footer.css';

const Footer = () => {

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <motion.div
            className="footer-brand"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h3 className="footer-logo">
              <img src="/images/Company_logo_new.png" alt="GlobeSoft Solutions Logo" className="footer-logo-image" />
              GlobeSoft Solutions
            </h3>
            <p className="footer-tagline">
              Transforming Ideas into Intelligent Solutions
            </p>
            <p className="company-description">
              Leading technology company specializing in cutting-edge digital solutions. 
              We deliver innovative applications that drive business growth and transformation. 
              Expert team providing scalable, efficient solutions for global clients.
            </p>
          </motion.div>

          <motion.div
            className="footer-services"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <h4 className="footer-heading">Services</h4>
            <p className="footer-service">AI Agents Development</p>
            <p className="footer-service">Application Development</p>
            <p className="footer-service">Backend Development</p>
            <p className="footer-service">CRM Systems</p>
            <p className="footer-service">Web Development</p>
            <p className="footer-service">Cloud Hosting</p>
            <p className="footer-service">UI/UX Design</p>
          </motion.div>

          <motion.div
            className="footer-tech-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h4 className="footer-heading">Mobile Technologies</h4>
            <div className="tech-items">
              <span className="footer-service">Flutter Development</span>
              <span className="footer-service">React Native Development</span> 
            </div>
          </motion.div>

          <motion.div
            className="footer-tech-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <h4 className="footer-heading">Web Technologies</h4>
            <div className="tech-items">
              <span className="footer-service">React.js Development</span> 
              <span className="footer-service">Next.js Development</span> 
              <span className="footer-service">Angular Development</span> 
              <span className="footer-service">Vue Js Development</span> 
            </div>
          </motion.div>

          <motion.div
            className="footer-tech-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
          >
            <h4 className="footer-heading">Backend Technologies</h4>
            <div className="tech-items">
              <span className="footer-service">Golang Development</span>
              <span className="footer-service">Python Development</span>
              <span className="footer-service">Java Development</span>
              <span className="footer-service">Node.js Development</span>  
            </div>
          </motion.div>

        </div>

        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          <p className="copyright">
            © 2019 GlobeSoft Solutions. All rights reserved.
          </p>
        </motion.div>

      </div>
    </footer>
  );
};

export default Footer;

